import { Card } from './primitives';

import type { ReactNode } from 'react';

/** Empty-state for screens whose real implementation lands in a later phase. */
export function ComingSoonPanel({
    icon,
    title,
    blurb,
}: {
    icon?: ReactNode;
    title: string;
    blurb: string;
}) {
    return (
        <Card>
            <div className="flex flex-col items-center gap-3 px-6 py-16 text-center">
                {icon && (
                    <div className="flex size-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
                        {icon}
                    </div>
                )}
                <div className="text-base font-semibold text-gray-900">{title}</div>
                <p className="max-w-md text-sm text-gray-500">{blurb}</p>
                <span className="mt-1 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-500">
                    Coming soon
                </span>
            </div>
        </Card>
    );
}
